let menu = function(hasManageStudio,hasManageContentAudit){
    let arr = [{
        name: '首页',
        path: '/',
        icon: 'ios-home-outline',
        authority: 'Manage Edit'
    }]
    if(hasManageStudio || hasManageContentAudit){
        let obj = {
            name: '管理',
            icon: 'ios-paper-outline',
            authority: 'Manage Edit',
            children: []
        }
        if(hasManageStudio){
            obj.children.push({
                name: '育人号管理',
                path: '/manage/studio',
                match: ['manageStudioSingle'], // 如匹配路由name也可激活<Menu:activeName>
                authority: 'Manage'
            })
        }
        if(hasManageContentAudit){
            obj.children.push({
                name: '内容审核',
                path: '/manage/contentaudit',
                authority: 'Manage'
            })
        }
        arr.push(obj)
    }
    arr = arr.concat([
        {
            name: '数据统计',
            icon: 'stats-bars',
            authority: 'Manage Edit',
            children: [
                {
                    name: '育人号排序',
                    path: '/datastatistics/sort',
                    authority: 'Manage Edit'
                }
            ]
        },
        {
            name: '设置',
            icon: 'ios-gear-outline',
            authority: 'Manage Edit',
            children: [{
                    name: '账号信息',
                    path: '/settings/account',
                    authority: 'Manage Edit'
                }
            ]
        },
        {
            name: '系统管理',
            icon: 'ios-settings',
            authority: 'Manage Edit',
            children: [{
                    name: '工作简报',
                    path: '/system/work',
                    authority: 'Manage Edit'
                }
            ]
        }
    ])
    return arr
}
export default menu


// WEBPACK FOOTER //
// ./src/config/projectAdmin.js